import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type Optional<T> = {
  [K in keyof T]?: T[K];
};

export const deepEqual = (a: any, b: any): boolean => {
  if (a === b) return true;
  if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
      return false;
    }
  }
  return true;
};

export const abbreviateName = (fullName: string): string => {
  const surnamePrefixes = new Set([
    "van",
    "von",
    "de",
    "der",
    "den",
    "ten",
    "ter",
    "la",
    "le",
    "da",
    "di",
    "du",
  ]);

  // Remove company names in parentheses
  let name = fullName.replace(/\s*\([^)]*\)/g, "").trim();

  // Normalize spaces
  name = name.replace(/\s+/g, " ");

  const parts = name.split(" ");

  if (parts.length <= 1) {
    return name;
  }

  // Find where surname begins
  let surnameStart = parts.length - 1;

  while (surnameStart > 0 && surnamePrefixes.has(parts[surnameStart - 1].toLowerCase())) {
    surnameStart--;
  }

  const givenNames = parts.slice(0, surnameStart);
  const surname = parts.slice(surnameStart);

  // Create initials
  const initials = givenNames.map((part) => {
    if (part.includes("-")) {
      return part
        .split("-")
        .map((p) => p[0].toUpperCase())
        .join("-");
    }

    return part[0].toUpperCase();
  });

  return `${initials.join(".")}. ${surname.join(" ")}`;
};

export const downloadFileByUrl = (url: string, filename: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  if (url.startsWith("blob:")) {
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }
};
